import hewlett from "../../assests/HPE/Landing-page/Group.svg";

import frame from "../../assests/HPE/Landing-page/Frame.svg";
// import { Menu, X } from "lucide-react";
// import { useState } from "react";
// import Button from "../common/Button";
// import { Link } from "react-router-dom";

const Header = () => {
  // const [showMenu, setShowMenu] = useState(false);
  return (
    <header className="px-4 lg:px-6 absolute top-4 left-0 w-full">
      <div className="rounded-lg bg-white flex flex-col gap-2">
        <div className="py-4 px-4 md:px-16 flex gap-6 items-center justify-center">
          <div className="flex items-center justify-center">
            <a href="/" className="flex items-center justify-center gap-x-5">
              <div>
                <img src={hewlett} alt="hewlett" />
              </div>
              <div className="h-[40px]  border-r-4 border-black"></div>
              <div>
                <img src={frame} alt="frame" />
              </div>
            </a>
          </div>
          {/* <div className="flex items-center gap-3 md:gap-12">
            <button
              aria-label="hamburger-menu-button"
              className="text-blue-05"
              onClick={() => setShowMenu((prev) => !prev)}
            >
              {showMenu ? (
                <X className="block md:hidden" />
              ) : (
                <Menu className="block md:hidden" />
              )}
            </button>
            <Link to="/discounted-product" className="b3 hidden md:block">
              Discounted Products
            </Link>
            <a
              href="/pdfs/product-catalogue.pdf"
              download
              className="hidden md:block"
            >
              <Button text="Get Catalogue" Icon={null} styles="text-nowrap" />
            </a>
          </div> */}
        </div>
        {/* {showMenu && (
          <div className="max-w-full p-4 flex flex-col gap-6 md:gap-7 rounded-lg">
            <Link to="/discounted-product" className="b3">
              Discounted Products
            </Link>
          </div>
        )} */}
      </div>
    </header>
  );
};

export default Header;
